import { render, staticRenderFns } from "./CustomNavbarBrand.vue?vue&type=template&id=4c2a138f"
import script from "./CustomNavbarBrand.vue?vue&type=script&lang=js"
export * from "./CustomNavbarBrand.vue?vue&type=script&lang=js"
import style0 from "./CustomNavbarBrand.vue?vue&type=style&index=0&id=4c2a138f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports